import { useState } from 'react'

import * as Sentry from '@sentry/react'
import { signOut } from 'aws-amplify/auth'
import { useNavigate } from 'react-router'
import { accountCacheKey } from 'src/features/auth/api/cacheKey'
import { getSignOutRedirectUrl } from 'src/features/auth/utils/getSignOutRedirectUrl'
import { willRedirectOnSignOut } from 'src/features/auth/utils/willRedirectOnSignOut'
import { EXPLANATION_QUERY_STORAGE_KEY } from 'src/features/explanation/hooks/useExplanationsQueryParams'
import { useLocalStorage } from 'src/hooks/use-local-storage'
import { useResetMembers } from 'src/legacy_modules/entities/member/atom'
import { routes } from 'src/legacy_modules/routes'
import { rotateLoginId } from 'src/utils/rotateLoginId'
import { useSWRConfig } from 'swr'

import { logout } from './request'

export const useLogout = () => {
  const [requesting, setRequesting] = useState(false)
  const { resetData } = useLocalStorage(EXPLANATION_QUERY_STORAGE_KEY)
  const navigate = useNavigate()
  const resetMembers = useResetMembers()
  const { mutate } = useSWRConfig()

  const handleLogout = async () => {
    if (requesting) return

    setRequesting(true)
    try {
      // signOut()の前に判定する（signOut()がトークンを破棄すると判定できなくなるため）
      const willRedirect = await willRedirectOnSignOut()

      // signOut()はフルページ遷移を開始するため、API側のセッション破棄を先に済ませる。
      // ただしAPI側の失敗でCognito / Auth0のサインアウトが止まらないよう best-effort とする。
      try {
        await logout()
      } catch (error) {
        // セッション切れ・ネットワーク断などで失敗しても後続のサインアウトは続行する。
        // ただし恒常的に失敗するとAPI側セッションが残り続けるため気付けるようにしておく。
        Sentry.captureException(error)
      }
      await signOut({
        global: false,
        oauth: { redirectUrl: getSignOutRedirectUrl() },
      })
      rotateLoginId()
      resetMembers()
      mutate(accountCacheKey.getAccount, undefined, { revalidate: false })
      resetData()

      // signOut()がフルページ遷移を開始している場合は、ログイン画面へ動かさない。
      // 遷移が終わるまでの間ログイン画面が表示され、そのあと本物のログイン画面が
      // 読み込まれるため、リロードしたように見えてしまう。
      if (!willRedirect) {
        navigate(routes.login)
      }
    } finally {
      setRequesting(false)
    }
  }

  return { requesting, handleLogout }
}
